var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h2", { attrs: { tabindex: "-1" } }, [
        _vm._v(_vm._s(_vm.$t("Title_Organisation")))
      ]),
      _vm._v(" "),
      _vm.report.personnel ? _c("personnel-table-row") : _vm._e(),
      _vm._v(" "),
      _vm.report.personnel
        ? _c("radio-button-row", {
            attrs: { title: "Organisation.PublicSector", required: true },
            model: {
              value: _vm.report.personnel.publicSector,
              callback: function($$v) {
                _vm.$set(_vm.report.personnel, "publicSector", $$v)
              },
              expression: "report.personnel.publicSector"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.report.personnel
        ? _c("radio-button-row", {
            attrs: {
              title: "Organisation.ServiceOperation",
              instructionsKey: "Organisation.ServiceOperation_Instructions",
              required: true
            },
            model: {
              value: _vm.report.personnel.serviceOperation,
              callback: function($$v) {
                _vm.$set(_vm.report.personnel, "serviceOperation", $$v)
              },
              expression: "report.personnel.serviceOperation"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.report.personnel
        ? _c("radio-button-row", {
            attrs: {
              title: "Organisation.OtherPublicAid",
              instructionsKey: "Organisation.OtherPublicAid_Instructions",
              required: true
            },
            model: {
              value: _vm.report.personnel.otherPublicAid,
              callback: function($$v) {
                _vm.$set(_vm.report.personnel, "otherPublicAid", $$v)
              },
              expression: "report.personnel.otherPublicAid"
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }